import React from 'react';
import { Alert } from '@dev/ee-components';

import useMobile from '@/services/hooks/useMobile';
import { AlertWrapper } from '../../../StyledComponents';
import { StaleContactsAlertBody } from './StaleContactAlertBody';

export const StaleContactsAlert = () => {
    const isMobile = useMobile();

    return (
        <AlertWrapper isMobile={isMobile}>
            <Alert severity="info" body={<StaleContactsAlertBody />} />
        </AlertWrapper>
    );
};
